module.exports = "/_next/static/images/model_availibility-b36c1335b39183027d832de55df41315.jpg";